<template>
    <div class="container">
        <md-dialog :md-active.sync="modalCrear" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.identificacion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="identificacion" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.digitoVerif}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="digitoVerif" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.nombre}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="nombre" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.correo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="correo" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.telefono}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="telefono" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.direccion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="direccion" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.tipoTercero}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <select v-model="tipoTercero" class="form-control">
                            <option value="">{{labels.select}}</option>
                            <option v-for="tercero in listTipoTercero" :key="tercero.id" :value="tercero.tipo_tercero">{{ tercero.descripcion }}</option>
                        </select>
                    </b-col>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <md-button class="md-primary" @click="guardarTercero">{{ labels.save }}</md-button>
                    <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>

import TipoTerceros from '../../services/TipoTerceros';
import Tercero from '../../services/Tercero';

export default {
    name:'Crear',
    props:['modalCrear'],
    data:() => ({
        identificacion : '',
        digitoVerif : null,
        nombre : '',
        correo : '',
        telefono : '',
        direccion : '',
        tipoTercero : '',
        listTipoTercero : []
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Crear Tercero',
                    save : 'Guardar',
                    close : 'Cerrar',
                    identificacion : 'Identificación',
                    digitoVerif : 'Digito verificación',
                    nombre : 'Nombre',
                    correo : 'Correo',
                    telefono : 'Telefono',
                    direccion : 'Dirección',
                    tipoTercero : 'Tipo tercero',
                    select : 'Seleccione...'
                }
            }else{
                return {
                    title : 'Create Third',
                    save : 'Save',
                    close : 'Close',
                    identificacion : 'ID',
                    digitoVerif : 'Verification digit',
                    nombre : 'Name',
                    correo : 'Email',
                    telefono : 'Phone',
                    direccion : 'Address',
                    tipoTercero : 'Tipo tercero',
                    select : 'Select...'
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        guardarTercero(){
            const valores = [
                this.identificacion, 
                this.digitoVerif, 
                this.nombre,
                this.correo,
                this.telefono,
                this.direccion,
                this.tipoTercero
            ]
            // console.log(valores);
            if(valores.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{
                // this.$toast.success('Envia form')
                let info = {
                    'identificacion'  : this.identificacion, 
                    'digitoVerificacion'  : this.digitoVerif, 
                    'nombre'  : this.nombre,
                    'correo'  : this.correo,
                    'telefono'  : this.telefono,
                    'direccion'  : this.direccion,
                    'tipoTercero'  : this.tipoTercero,
                    'idUser'    : this.$store.state.userId
                }

                Tercero.createTercero(info)
                .then((res) => {
                    if(res.status == 201){
                        this.$toast.success(res.data.message)
                        location. reload()
                    
                    }else if(res.status == 204){
                        this.$toast.error('Tercero ingresado ya existe.')
                    }
                })
                .catch((error) => { console.log(error) })
            }
        }
    },
    mounted(){
        TipoTerceros.getAllTipoTerceros()
        .then((res) => {
            // console.log(res.data.listTipoTerceros);
            this.listTipoTercero = res.data.listTipoTerceros
        })
        .catch((error) => {console.log(error)})
    }
}
</script>

<style>

</style>